import { __require as a } from "./map_object.js";
var r, n;
function f() {
  if (n) return r;
  n = 1;
  var o = a();
  return r = function(u, c) {
    var e = {};
    return o(u, function(t, i) {
      c(t, i) && (e[i] = t);
    }), e;
  }, r;
}
export {
  f as __require
};
